<script>


  let y
</script>

<svelte:window bind:scrollY={y} />

<section>

  <div class="hero-banner">
    <h2>Aménagement extérieur</h2>
    <img src="/home-out.svg" alt="jardin extérieur">
    <p>Laissez-nous faire de votre jardin un havre de paix ! Nous utilisons de nombreuses plantes, faciles d'entretien, pour embellir votre extérieur. Nos partenaires locaux seront également ravis de vous offrir leur expertise sur l'implantation de piscine pour profiter de l'été.</p>
  </div>

  <div class="img-section">
    <div class="img-wrapper">
      <img class="balcon" src="/balcon.svg" alt="Balcon d'appartement">
      <img class="midnight" src="/midnight.svg" alt="Petite cour intérieur de nuit">
      <img class="bike" src="/yellow-bike.svg" alt="Vélo jaune ancien">
    </div>
  </div>

  <div class="hero-banner pink">
    <h3>Passez le plus dépaysant des été dans votre jardin</h3>
    <img src="/outside-sofa.svg" alt="Salon de jardin">
  </div>

  <div class="parallax-img">
    <div class="parallax-wrapper">
      <img style="top: {y * 0.1 - 300}px;" src="/parallax-pool.svg" alt="Petit jardin avec piscine de type bain romain">
      <img style="bottom: {y * 0.1 - 300}px" src="/parallax-outside.svg" alt="Salon de jardin de nuit">
    </div>
  </div>

  <div class="outside-pool">
    <img src="/outside-pool.svg" alt="Piscine extérieure avec vue dans le désert">
  </div>

</section>


<style>

  .hero-banner{
    display: flex;
    flex-direction: column;
    align-items: center;

    margin: 50px 0;
    padding: 50px 0;

    background: var(--main-color);
  }

  .pink{
    background: #FCC6C6;
  }

  .hero-banner img{
    margin: 50px 0;

    width: min(400px, 70%);
  }

  .hero-banner h2{
    width: 100%;
    
    text-align: center;
    text-transform: uppercase;
  }

  .hero-banner h3{
    width: 100%;
    
    text-align: center;
    text-transform: uppercase;
    color: #585858;
  }

  .hero-banner p{
    width: min(350px, 70%);

    text-align: justify;
    color: #7C7C7C;
  }

  .img-section{
    width: 100%;
    height: min(200vw, 1600px);

    margin-bottom: 50px;
  }

  .img-wrapper{
    width: 100%;
    max-width: 800px;
    height: 100%;

    margin: 0 auto;

    position: relative;
  }

  .img-wrapper img{
    position: absolute;
  }

  .balcon{
    top: 0;
    right: 0;

    width: 70%;
  }

  .midnight{
    top: 45%;
    left: 50%;

    width: 80%;

    z-index: -1;

    transform: translate(-50%, -50%);
  }

  .bike{
    bottom: 0;
    left: 50%;

    width: 60%;

    transform: translateX(-50%);
  }

  .parallax-img{
    height: min(150vw, 1000px);

    margin-bottom: 50px;
  }

  .parallax-wrapper{
    position: relative;

    width: min(100%, 600px);
    height: 100%;

    margin: 0 auto;
  }

  .parallax-img img:nth-child(1){
    position: absolute;

    right: 0;
    top: 0;

    width: 60%;
  }
  .parallax-img img:nth-child(2){
    position: absolute;
    
    left: 0;
    bottom: 0;

    width: 60%;
  }

  .outside-pool{
    width: 100%;

    background: #D1EFED;

    display: flex;
    justify-content: center;
  }

  .outside-pool img{
    width: min(80%, 500px);
  }


</style>